import React from 'react'
import { MoreVert } from '@mui/icons-material'
import { localizedStrings } from '@core/strings'
import { DropdownButton, IconButton } from '@common/material'
import { DropdownButtonOption } from '@common/material/DropdownButton/types'
import { useModal } from '@common/GlobalModal'
import { Permit } from '@core/entities/permit/Permit'
import { CheckInSession } from '@core/entities/checkIn'
import { ForceCheckOutModal } from './modals/ForceCheckOutModal'
import useFeatureFlags from '@core/providers/useFeatureFlags'

type ComponentType = {
  permit: Permit
  session?: CheckInSession
}

export const PermitPersonCheckInActions: React.FC<ComponentType> = ({
  permit,
  session,
}) => {
  const { showModal } = useModal()
  const { flags } = useFeatureFlags(['web_permit_check_in'])

  if (
    !flags.web_permit_check_in ||
    !permit.hasPermission('FORCE_CHECK_OUT') ||
    !session?.isOpen()
  ) {
    return null
  }

  const options: DropdownButtonOption[] = [
    {
      title: localizedStrings.forceCheckOut,
      'data-test': 'dd-force-check-out',
      onSelect: () =>
        showModal(
          <ForceCheckOutModal permitId={permit.id} session={session} />,
        ),
    },
  ]

  return (
    <DropdownButton
      label={localizedStrings.actions}
      options={options}
      renderButton={(onClick) => (
        <IconButton
          size='small'
          onClick={(e) => {
            e.stopPropagation()
            onClick(e)
          }}
          onBlur={(e) => e.stopPropagation()}
          data-test='dd-permit-person-check-in-actions'
        >
          <MoreVert fontSize='small' />
        </IconButton>
      )}
    />
  )
}
